// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"bce2930c","197":"ab2b5557","436":"fbb6b015","496":"234faf2d","521":"f52fb286","587":"37037352","671":"ef122d75","787":"6f5d094e","894":"bb376643","967":"2d9747d8","984":"792f4819"}[chunkId] + ".chunk.js";
};